import { StytchB2BUIClient } from '@stytch/vanilla-js/b2b';
import { useRef } from 'react';

import { getEnvVariable } from '~/dev/utils/getEnvVariable';
import { rolodex } from '~/services/serviceInstances';

const StytchOptions = {
  cookieOptions: {
    opaqueTokenCookieName: 'session_token',
    jwtCookieName: 'session_jwt',
    path: '',
    availableToSubdomains: false,
    domain: '',
  },
};

export const useStytchClient = () => {
  // Always call useRef first to comply with Rules of Hooks
  const StytchB2BUIClientRef = useRef<StytchB2BUIClient | undefined>(undefined);

  // TODO: EKP-33716 This completely disables stytch for all clients.
  //  We want to re-enable stytch when back to it.
  const shouldSkipStytch = true;

  if (shouldSkipStytch) {
    return { b2bClient: undefined };
  }

  // Initialize the client only if not already initialized and not EU domain
  if (!StytchB2BUIClientRef.current) {
    StytchB2BUIClientRef.current = new StytchB2BUIClient(
      getEnvVariable('REACT_APP_STYTCH_PUBLIC_TOKEN'),
      StytchOptions,
    );
    // Override the authenticate method
    StytchB2BUIClientRef.current.passwords.authenticate = async (
      request: never,
    ) => {
      // This is a temporary solution, as stytch doesn't support htpponly, we have to use
      // rolodex as a proxy to set the token with httponly flag
      return await rolodex.post('proxy/passwords/authenticate', request);
    };
  }

  return {
    b2bClient: StytchB2BUIClientRef.current,
  };
};
